import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { CookieServiceService } from './cookie-service.service';
import { EMPTY } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService {

  constructor(private cookieService: CookieServiceService,
    private router: Router) { }
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (httpRequest.url.endsWith("/Captcha")
      || httpRequest.url.endsWith("/getOTP")|| httpRequest.url.endsWith("/getKey")
      || httpRequest.url.endsWith("/validateOTP") 
      || httpRequest.url.endsWith("/sendotpviacall")
      || httpRequest.url.endsWith("/getSOL")
      || httpRequest.url.endsWith("/getEpoint")) {        
      return next.handle(httpRequest);
    }
    let isValidRequest = this.cookieService.isTokenValid();
    if (!isValidRequest) {
      let error = {
        status: 403,
        message: "Invalid request"
      }
      var HTTPOptions = {
        headers: new HttpHeaders({
          'content-type': 'json' as 'blob'
        }),
        // 'responseType': 'blob' as 'json'
      }
      this.router.navigate(['/Default']);
      return EMPTY;
    }
    return next.handle(httpRequest);
  }
}
